import _createClass from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { wrapperGet, wrapperPost } from '@/utils/http';
export default new ( /*#__PURE__*/_createClass(function ShoppingCartApi() {
  _classCallCheck(this, ShoppingCartApi);
  /*
   * 购物车列表
   * */
  _defineProperty(this, "cartList", wrapperGet('/api/client-ubq-app/cart/list'));
  /*
   * 添加购物车
   * */
  _defineProperty(this, "cartAdd", wrapperPost('/api/client-ubq-app/cart/add'));
  /*
   * 移除购物车
   * */
  _defineProperty(this, "cartRemove", wrapperPost('/api/client-ubq-app/cart/remove'));
  /*
   * 获取购物车数量
   * */
  _defineProperty(this, "cartCount", wrapperGet('/api/client-ubq-app/cart/count'));
  /*
   * 购物车下单支付通道
   * */
  _defineProperty(this, "paymentChannel", wrapperGet('/api/client-ubq-app/cart/paymentChannel'));
}))();